import * as React from 'react';
import List from '@mui/joy/List';
import ListSubheader from '@mui/joy/ListSubheader';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListItemContent from '@mui/joy/ListItemContent';

import InboxRoundedIcon from '@mui/icons-material/InboxRounded';
import CodeIcon from '@mui/icons-material/Code';
import ApiGuideModal from './ApiGuide.tsx';
import { useState } from 'react';

export default function Navigation() {
  const [openApiGuide, setOpenApiGuide] = useState(false);
  
  return (
    <List size="sm" sx={{ '--ListItem-radius': '8px', '--List-gap': '4px' }}>
      <ListItem nested>
        <ListSubheader sx={{ letterSpacing: '2px', fontWeight: '800' }}>
          Browse
        </ListSubheader>
        <List aria-labelledby="nav-list-browse">
          <ListItem>
            <ListItemButton selected>
              <ListItemDecorator>
                <InboxRoundedIcon fontSize="small" />
              </ListItemDecorator>
              <ListItemContent>Inbox</ListItemContent>
            </ListItemButton>
          </ListItem>
          <ListItem onClick={() => setOpenApiGuide(true)}>
            <ListItemButton>
              <ListItemDecorator>
                <CodeIcon fontSize="small" />
              </ListItemDecorator>
              <ListItemContent>API</ListItemContent>
            </ListItemButton>
          </ListItem>
        </List>
      </ListItem>

      <ApiGuideModal open={openApiGuide} onClose={() => setOpenApiGuide(false)} />
    </List>
  );
}